import React, { useContext, useState, useEffect } from 'react';
import { Form, Input, Select, Empty, message } from '@drip/drip-design';
import FilterTag from '@/components/filter-tag';
import FilterBoxes from '@/components/filter-boxes';
import './index.less';
import ProviderUserTypeInfo from '../../provider-userType-info';
import apis from '../../apis';
import { cppBaseSex, cppBaseAge, cppAddrProvince, isPlus } from './data.js';
import UserBaseInfo from './components/user-base-info';
import UserShoppingInfo from './components/user-shopping-info';
import UserUgInfo from './components/user-ug-info';

export default function (props) {
  const value = useContext(ProviderUserTypeInfo);
  const [tab, setTab] = useState(1);
  const [activityName, setActivityName] = useState([]);
  const { planCode, platformCd, startTime, endTime, realTimeData = false } = props;
  const [conditions, setConditions] = useState({ dataType: 'expo' });
  const [form] = Form.useForm();
  const dataTypeList = [
    {
      value: '曝光用户',
      id: 'expo',
    },
    {
      value: '点击用户',
      id: 'click',
    },
    {
      value: '成交用户',
      id: 'ord',
    },
  ];
  useEffect(() => {
    apis
      .queryActivityScopeList({ ...value, planCode })
      .then((res) => {
        const {
          ret,
          msg,
          data: { activityName = [] },
        } = res;
        if (ret === '0') {
          setActivityName(activityName);
        } else {
          message.error(msg);
          setActivityName([]);
        }
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [value, planCode]);

  useEffect(() => {
    setConditions((conditions) =>
      Object.assign(
        {},
        conditions,
        { planCode: planCode },
        {
          startTime: startTime,
        },
        { endTime: endTime },
        {
          platformCd: platformCd,
        },
        {
          realTimeData: realTimeData,
        },
        {
          ...value,
        }
      )
    );
  }, [planCode, startTime, endTime, platformCd, value, realTimeData]);
  const onFinish = (val) => {
    setConditions({ ...conditions, ...val });
  };
  return (
    <div className="participant-data-user-analysis-bg">
      {realTimeData ? (
        <div className="participant-data-user-analysis-card">
          <Empty />
        </div>
      ) : (
        <>
          <div className="participant-data-user-analysis-card">
            <Form.Item label="用户类型">
              <FilterTag.Group
                border={false}
                onChange={(value) => {
                  setConditions({ ...conditions, dataType: value });
                }}
                defaultValue="expo"
              >
                {dataTypeList.map((item) => {
                  return (
                    <FilterTag value={item.id} key={item.id}>
                      {item.value}
                    </FilterTag>
                  );
                })}
              </FilterTag.Group>
            </Form.Item>

            <FilterBoxes form={form} onFinish={onFinish}>
              <Form.Item name="activityId" span={4} label="会场名称:">
                <Select
                  allowClear={true}
                  showSearch
                  filterOption={(input, option) =>
                    (option.children.toLowerCase() + option.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="请选择"
                >
                  {activityName.length > 0 &&
                    activityName.map((item, index) => (
                      <Select.Option key={index} value={item.value}>
                        {item.name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item name="cppBaseSex" span={3} label="性别:">
                <Select
                  allowClear={true}
                  showSearch
                  filterOption={(input, option) =>
                    (option.children.toLowerCase() + option.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="请选择"
                >
                  {cppBaseSex.map((item, index) => (
                    <Select.Option key={index} value={item}>
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="cppBaseAge" span={4} label="年龄:">
                <Select
                  allowClear={true}
                  showSearch
                  filterOption={(input, option) =>
                    (option.children.toLowerCase() + option.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="请选择"
                >
                  {cppBaseAge.map((item, index) => (
                    <Select.Option key={index} value={item}>
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="cppAddrProvince" span={3} label="省份:">
                <Select
                  allowClear={true}
                  showSearch
                  filterOption={(input, option) =>
                    (option.children.toLowerCase() + option.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="请选择"
                >
                  {cppAddrProvince.map((item, index) => (
                    <Select.Option key={index} value={item}>
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="isPlus" span={3} label="会员:">
                <Select
                  allowClear={true}
                  showSearch
                  filterOption={(input, option) =>
                    (option.children.toLowerCase() + option.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="请选择"
                >
                  {isPlus.map((item, index) => (
                    <Select.Option key={index} value={item.val}>
                      {item.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </FilterBoxes>
          </div>

          <div className="participant-data-user-analysis-card">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div
                className={'participant-data-user-tab' + (tab === 1 ? ' select' : '')}
                onClick={() => {
                  setTab(1);
                }}
              >
                用户基础属性
              </div>
              <div className="participant-data-user-line" />
              <div
                className={'participant-data-user-tab' + (tab === 2 ? ' select' : '')}
                onClick={() => {
                  setTab(2);
                }}
              >
                用户购物属性
              </div>
              <div className="participant-data-user-line" />
              <div
                className={'participant-data-user-tab' + (tab === 3 ? ' select' : '')}
                onClick={() => {
                  setTab(3);
                }}
              >
                用户增长属性
              </div>
            </div>
          </div>
          {tab === 1 && <UserBaseInfo conditions={conditions} />}
          {tab === 2 && <UserShoppingInfo conditions={conditions} />}
          {tab === 3 && <UserUgInfo conditions={conditions} />}
        </>
      )}
    </div>
  );
}
